const couponErrors = {
  FALLBACK: "Mit diesem Gutschein gibt es ein Problem",
  MINIMUM: "Der Mindestbestellwert für diesen Gutschein ist ",
  CANNOT_CHECK: "Wir können diesen Gutschein aktuell leider nicht prüfen",
  NOT_STARTED: "Der Aktionszeitraum für diesen Gutschein hat noch nicht begonnen",
  ENDED: "Dieser Gutschein ist abgelaufen",
  UNKNOWN: "Diesen Gutschein gibt es leider nicht",
  USAGE_LIMIT_REACHED: "Dieser Gutschein wurde schon zu oft verwendet",
}

export { couponErrors }
